import { render } from "./xuenjiainfo.vue?vue&type=template&id=5e2958c8&scoped=true"
import script from "./xuenjiainfo.vue?vue&type=script&lang=js"
export * from "./xuenjiainfo.vue?vue&type=script&lang=js"

import "./xuenjiainfo.vue?vue&type=style&index=0&id=5e2958c8&lang=scss&scoped=true"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2958c8"]])

export default __exports__